module.exports = __webpack_public_path__ + "img/shexiangtou.025d9c18.png";